import DynamicSection from "./dynamic_section"
import Nav from "./nav"
import Search from "./search"
import Swiper from "./swiper"
import Fancybox from "./fancybox"

document.addEventListener("DOMContentLoaded", function () {
  DynamicSection(jQuery)
  Nav(jQuery)
  Search(jQuery)
  Swiper(jQuery)
  Fancybox(jQuery)
})
